// API مربوط به بخش مالی کاربر

import { httpClient } from "./httpClient";

// خلاصه وضعیت مالی: موجودی، جمع تراکنش‌ها و ...
export function getFinanceSummary() {
  return httpClient.get("/user/finance/summary");
}

// لیست تراکنش‌های مالی با صفحه‌بندی
export function getTransactions({ page = 1, limit = 10 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  return httpClient.get(`/user/finance/transactions?${params.toString()}`);
}
